import React, { Component } from 'react';

class BackgroundImage extends Component {
    render() {
        return (
            <div className="background">
            </div>
        );
    }
}

BackgroundImage.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default BackgroundImage;


// WEBPACK FOOTER //
// ./src/components/BackgroundImage.js